
/* SDM Webpack 5 */

/* Stylesheets */
import './scss/vendors/bootstrap.scss'; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
//import './scss/vendors/swiper.scss'; // ref: https://swiperjs.com/get-started#installation
import './scss/vendors/hamburgers.scss'; // ref: https://jonsuh.com/hamburgers/#sass
import './scss/fonts.scss';
import './scss/forms.scss';
//import 'select2/src/scss/core.scss';
import "@fancyapps/ui/src/Fancybox/Fancybox.scss";
//import 'aos/src/sass/aos.scss';
//import './scss/vendors/energy-saver.scss';
import './scss/style.scss';

/* Scripts */
/* ### bootstrap*/
// import * as bootstrap from 'bootstrap'; // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.
// or, specify which plugins you need:
//import { Tooltip, Toast, Popover, Modal } from 'bootstrap';

/* ### jquery*/
import $ from 'jquery';
require('jquery.easing')
window.jQuery = $;
window.$ = $;

/* ### swiper*/
// import Swiper from 'swiper'; // ref: https://swiperjs.com/get-started#install-from-npm
// import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

/* ### AOS*/
//import AOS from 'aos';

/* ### imagesloaded*/
//import ImagesLoaded  from 'imagesloaded';
const imagesload = require('imagesloaded');

/* ### fancyapps*/
import { Fancybox } from "@fancyapps/ui";

/* ### cleave*/
import { Cleave } from 'cleave.js';
require('cleave.js/dist/addons/cleave-phone.it');
//import path from '/_common/prefix.json'

/* ### select2*/
//import { select2 } from 'select2';
//require('select2/dist/js/i18n/it.js');

/* ### fontawesome*/
import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { fab } from '@fortawesome/free-brands-svg-icons';
// import { fas } from '@fortawesome/pro-solid-svg-icons';
// import { far } from '@fortawesome/pro-regular-svg-icons';
// import { fal } from '@fortawesome/pro-light-svg-icons';
// import { fat } from '@fortawesome/pro-thin-svg-icons';
// import { fad } from '@fortawesome/pro-duotone-svg-icons';
// import { fass } from '@fortawesome/sharp-solid-svg-icons';
// import { fasr } from '@fortawesome/sharp-regular-svg-icons';
// import { fasl } from '@fortawesome/sharp-light-svg-icons';
// import { fast } from '@fortawesome/sharp-thin-svg-icons';
// library.add(fab, fas, far, fal, fat, fad, fass, fasr, fasl, fast);
// dom.i2svg();

//import { fal } from '@fortawesome/pro-light-svg-icons';
import { faHouse as faHouseLight } from '@fortawesome/pro-light-svg-icons';
import { faRightFromBracket as faRightFromBracketLight } from '@fortawesome/pro-light-svg-icons';
library.add(faHouseLight, faRightFromBracketLight);
dom.i2svg();

/* ##################################################### EnergySaver*/
/*import EnergySaver from './js/vendors/energy-saver';*/

/*  Functions */

/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};
const isDebug = process.env.NODE_ENV !== 'production';

/* Variables and functions */
/*let deviceWidth, deviceHeight;*/
let isAnimating = false;
let urlHash;

// webpack version
const initWebpackVersion = () => {
    isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

// scrollToElm 
const scrollToElm = (n) => {
    var hh;
    if ($('header').hasClass('sticky-top') || $('header').hasClass('position-fixed')) {
        hh = $('header').outerHeight();
    } else {
        hh = 0;
    }
    var elm = $('*[data-anchor=' + n + ']').offset().top - hh;
    $('html, body').animate({
        scrollTop: elm + 1
    }, 500, 'easeInOutQuart', function () {
        //setFocusOnElement(document.querySelector('*[data-anchor=' + n + ']'));
    });

    $('header .hamburger').removeClass('is-active');
    $('header .item-nav').removeClass('is-active');
    $('[aria-expanded]').each(function (i, el) {
        $(this).attr('aria-expanded', 'false');
    });
}

// scrollToHash
//function scrollToHash(hash) {
//    if (hash) {
//        if ($('*[data-anchor=' + hash + ']').length > 0) {
//            var hh;
//            if ($('header').hasClass('sticky-top') || $('header').hasClass('position-fixed')) {
//                hh = $('header').outerHeight();
//            } else {
//                hh = 0;
//            }
//            var elm = $('*[data-anchor=' + hash + ']').offset().top - hh;
//            $('html, body').animate({
//                scrollTop: elm + 1
//            }, 500, 'easeInOutQuart', function () {
//                setFocusOnElement(document.querySelector('*[data-anchor=' + hash + ']'));
//            });

//            $('header .hamburger').removeClass('is-active');
//            $('header .item-nav').removeClass('is-active');
//            $('[aria-expanded]').each(function (i, el) {
//                $(this).attr('aria-expanded', 'false');
//            });
//        }
//    }
//}

// scrollToFirstErr
//const scrollToFirstErr = (n) => {
//    var hh;
//    if ($('header').hasClass('sticky-top') || $('header').hasClass('position-fixed')) {
//        hh = $('header').outerHeight();
//    } else {
//        hh = 0;
//    }
//    var elm = $('.invalid-feedback:visible:first').parent().get(0).getBoundingClientRect();
//    var pos = elm.top + $(window)['scrollTop']() - hh;
//    $('html, body').animate({
//        scrollTop: pos - 10
//    }, 500, 'easeInOutQuart', function () {

//    });

//    // todo: focus on invalid field
//    /*$('.invalid-feedback:visible:first').closest('div').find('input:first').trigger("focus");*/
//}

// setFocusOnElement
//function setFocusOnElement(target) {
//    var focusable = target.querySelectorAll('input, select, textarea, button:not([data-focusable="-1"]), [href]:not([data-focusable="-1"]), [tabindex]:not([data-focusable="-1"])');
//    var firstFocusable = focusable[0];
//    //console.log(firstFocusable);
//    if (firstFocusable) {
//        firstFocusable.focus();
//    }
//}

// fancybox 4
const showLoading = (cl) => {
    $('.wrapper').fadeTo(250, 0);
    var tmp = '<div class="fancybox__container is-animated ' + cl + ' role="dialog" tabindex="-1" aria-modal="true" aria-hidden="false" aria-label="" id="fancybox-loading"><div class="fancybox__backdrop"></div><div class="fancybox__spinner is-draggable"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="25 25 50 50" tabindex="-1"><circle cx="50" cy="50" r="20"></circle></svg></div></div>';
    $('body').append(tmp);
    $('#fancybox-loading').fadeIn();
}
const hideLoading = () => {
    $('#fancybox-loading').fadeOut(500, function () {
        $('#fancybox-loading').remove();
      
    });
    $('.wrapper').fadeTo(500, 1);
}
const closeFancybox = () => {
    Fancybox.close();
}
const popMessage = (n, cl) => {
    Fancybox.show([
        {
            src: "<p class='fs-normal m-0'>" + n + "</p>",
            type: "html"
        }
    ],
        {
            mainClass: cl,
            dragToClose: false,
            closeButton: "inside",
        }
    );
}
const popMessageModal = (n, cl) => {
    Fancybox.show([
        {
            src: "<p class='fs-normal m-0'>" + n + "</p>",
            type: "html",
            click: function () { return false; }
        }
    ],
        {
            mainClass: cl,
            closeButton: '',
            dragToClose: false,
            keyboard: false
        }
    );
}
const popInline = (n, cl) => {
    Fancybox.show([
        {
            src: n,
            type: "inline",
            click: function () { return false; }
        }
    ],
        {
            mainClass: cl,
            dragToClose: false,
            closeButton: "inside",
        }
    );
}

const popIframe = (n, cl) => {
    Fancybox.show([
        {
            src: n,
            type: "iframe",
            allow: "autoplay; fullscreen",
            scrolling: "auto",
            click: function () { return false; }
        }
    ],
        {
            mainClass: cl,
            dragToClose: false,
            closeButton: "inside",
        }
    );
}

// Asp validator
const ValidatorUpdateDisplay = (val) => {
    if (typeof (val.display) == "string") {
        if (val.display == "None") {
            return;
        }
        if (val.display == "Dynamic") {
            val.style.display = val.isvalid ? "none" : "block";
            ValidatorInput(val);
            return;
        }
    }
    if ((navigator.userAgent.indexOf("Mac") > -1) &&
        (navigator.userAgent.indexOf("MSIE") > -1)) {
        val.style.display = "inline-block";
    }
    val.style.visibility = val.isvalid ? "hidden" : "visible";
    ValidatorInput(val);
}

const ValidatorInput = (val) => {
    const elements = Array.from(val.parentNode.querySelectorAll('input, select, textarea'));
    const invalidClass = 'is-invalid';
    
    if (val.isvalid) {
        val.classList.remove(invalidClass);
    } else {
        val.classList.add(invalidClass);
    }

    const feedbacks = Array.from(val.parentNode?.querySelectorAll('.invalid-feedback'));
    const isInputInvalid = feedbacks.find(item => item.classList.contains(invalidClass));
    
    elements.forEach(elem => {
        isInputInvalid ? elem?.classList.add(invalidClass) : elem?.classList.remove(invalidClass);
        isInputInvalid ? elem?.setAttribute('aria-invalid', true) : elem?.removeAttribute('aria-invalid');
    });
}

const IsValidationGroupMatch = (control, validationGroup) => {
    if ((typeof (validationGroup) == "undefined") || (validationGroup == null)) {
        return true;
    }
    let controlGroup = "";
    if (typeof (control.validationGroup) == "string") {
        controlGroup = control.validationGroup;
    }
    return (controlGroup == validationGroup);
};

const ValidationSummaryOnSubmit = (validationGroup, message = null, target = null, success = false) => {

    const alertOffset = 2 //rem

    if (typeof (Page_ValidationSummaries) === "undefined")
        return;

    let summary, sums, s;
    var headerSep, first, pre, post, end;

    for (sums = 0; sums < Page_ValidationSummaries.length; sums++) {
        summary = Page_ValidationSummaries[sums];
        summary.style.display = "none";
        if (!Page_IsValid && IsValidationGroupMatch(summary, validationGroup)) {
            var i;
            if (summary.showsummary !== "False") {
                summary.style.display = "";
                if (typeof (summary.displaymode) !== "string") {
                    summary.displaymode = "BulletList";
                }
                switch (summary.displaymode) {
                    case "List":
                        headerSep = "<br />";
                        first = "";
                        pre = "";
                        post = "<br />";
                        end = "";
                        break;
                    case "BulletList":
                    default:
                        headerSep = "";
                        first = "<ul class='d-none'>";
                        pre = "<li>";
                        post = "</li>";
                        end = "</ul>";
                        break;
                    case "SingleParagraph":
                        headerSep = " ";
                        first = "";
                        pre = "";
                        post = " ";
                        end = "<br />";
                        break;
                }
                s = "";
                if (typeof (summary.headertext) === "string") {
                    s += summary.headertext + headerSep;
                }
                s += first;
                for (i = 0; i < Page_Validators.length; i++) {
                    if (!Page_Validators[i].isvalid && typeof (Page_Validators[i].errormessage) == "string") {
                        s += pre + Page_Validators[i].errormessage + post;
                    }
                }
                s += end;
                summary.innerHTML = s;
            }
            if (summary.showmessagebox === "True") {
                s = '';
                if (typeof (summary.headertext) === "string") {
                    s += summary.headertext + "<br />";
                }
                var lastValIndex = Page_Validators.length - 1;
                for (i = 0; i <= lastValIndex; i++) {
                    if (!Page_Validators[i].isvalid && typeof (Page_Validators[i].errormessage) === "string") {
                        switch (summary.displaymode) {
                            case "List":
                                s += Page_Validators[i].errormessage;
                                if (i < lastValIndex) {
                                    s += "<br />";
                                }
                                break;
                            case "BulletList":
                            default:
                                s += "- " + Page_Validators[i].errormessage;
                                if (i < lastValIndex) {
                                    s += "<br />";
                                }
                                break;
                            case "SingleParagraph":
                                s += Page_Validators[i].errormessage + " ";
                                break;
                        }
                    }
                }
                s += "";
                //scrollToFirstErr();
                popMessage(s);
                return;
            } else {
                //scrollToFirstErr();
                return;
            }
        }
    }
}

var forms = document.querySelectorAll('form');
Array.prototype.slice.call(forms)
	.forEach(function (form) {
		let allInputs = form.querySelectorAll('input, select, textarea');
		allInputs.forEach(function (el) {
			el.addEventListener('change', function (event) {
				if (el.checkValidity()) {
					el.removeAttribute('aria-invalid');
				} else {
					el.setAttribute('aria-invalid', 'true');
				}
			});
		});
	});

// Init Swiper
/*const initSwiperExample = () => {
    new Swiper('.SwiperExample', {
        modules: [Navigation, Pagination],
        navigation: {
            prevEl: '.SwiperExample .swiper-button-prev',
            nextEl: '.SwiperExample .swiper-button-next'
        },
        pagination: {
            el: '.SwiperExample .swiper-pagination',
            clickable:true
        }
    });
}*/

// Height 100% of viewport (trick for bars)
let windowWidth = 0;
const appHeight = () => {
    const currentWindowWidth = window.innerWidth;
    if (currentWindowWidth !== windowWidth) {
        windowWidth = currentWindowWidth;
        const doc = document.documentElement;
        doc.style.setProperty('--vph-100', `${window.innerHeight}px`);
    }
};
appHeight();
window.addEventListener('resize', appHeight);

// AOS
//AOS.init({
//    // Global settings:
//    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
//    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
//    initClassName: 'aos-init', // class applied after initialization
//    animatedClassName: 'aos-animate', // class applied on animation
//    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
//    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
//    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
//    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
//    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
//    offset: 120, // offset (in px) from the original trigger point
//    delay: 0, // values from 0 to 3000, with step 50ms
//    duration: 1000, // values from 0 to 3000, with step 50ms
//    easing: 'ease', // default easing for AOS animations
//    once: false, // whether animation should happen only once - while scrolling down
//    mirror: false, // whether elements should animate out while scrolling past them
//    anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

//});

// interactionEvent
/*const interactionEvent = (event = "", contentType = "") => {
    //console.log(event, contentType);
    dataLayer.push({
        'event': event,
        'content_type': contentType
    });
}*/

// flexfont (add css class .flexFont to container per scale child font-size)
//const flexFont = () => {
//    $('.flexFont').each(function () {
//        var relFontsize = $(this).width() * 0.2;
//        $(this).css('font-size', relFontsize + 'px').css('line-height', relFontsize + 'px')
//    });
//};

//EnergySaver
//const energyS = new EnergySaver({
//	enableZeroImpact:true
//});

// show spinner (btn)
//const showSpinner = (n) => {
//    $(n).prop('disabled', true).attr('aria-disabled', true).addClass('disabled');
//    $('.spinner-border', n).removeClass('d-none');
//    $('.spinner-status', n).html('Wait...');
//}

//// hide spinner (btn)
//const hideSpinner = (n, t) => {
//    $(n).prop('disabled', false).attr('aria-disabled', false).removeClass('disabled');
//    $('.spinner-border', n).addClass('d-none');
//    $('.spinner-status', n).html(t);
//}

//$(window).on('resize',function () {
//    deviceWidth = $(window).width();
//    deviceHeight = $(window).height();
//    //flexFont();
//});

//$(window).on('hashchange', function () {
//    urlHash = location.hash.replace(/^#/, '');
//    scrollToHash(urlHash);
//});


//Memory
var cardsArray = Array.from({ length: 3 }, (_, i) => i + 1);
function startMemory() {
    $('.memory .over').hide();
    $('.container-game').fadeTo(500, 1);
    $('.btn.start').fadeTo(250,0);
}
function shuffleArray() {
    var array = cardsArray;
    let currentIndex = array.length, randomIndex;
    while (currentIndex > 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
    return array;
}

const pushCards = () => {
    for (var i = 0; i < 3; i++) {
        $('.memory-game').append('<div class="memory-card position-relative" data-framework="card' + (cardsArray[i] + 1) + '"><img class="area" src="_common/images/cards/area.png" /><img class="front-face" src="_common/images/cards/card_' + cardsArray[i] + '.png" /><img class="back-face" src="_common/images/cards/retro.png" /></div>');
        $('.memory-game').append('<div class="memory-card position-relative" data-framework="card' + (cardsArray[i] + 1) + '"><img class="area" src="_common/images/cards/area.png" /><img class="front-face" src="_common/images/cards/card_' + cardsArray[i] + '.png" /><img class="back-face" src="_common/images/cards/retro.png" /></div>');
    }
    setTimeout(function () {
        hideLoading();
        initMemory();
    }, 1000);
}
const initMemory = () => {
    const cards = document.querySelectorAll('.memory-card');

    let hasFlippedCard = false;
    let lockBoard = false;
    let firstCard, secondCard;
    var count = 0;
    function flipCard() {
        if (lockBoard) return;
        if (this === firstCard) return;
        this.classList.add('flip');
        if (!hasFlippedCard) {
            hasFlippedCard = true;
            firstCard = this;
            return;
        }
        secondCard = this;
        checkForMatch();
    }
    function checkForMatch() {
        let isMatch = firstCard.dataset.framework === secondCard.dataset.framework;
        isMatch ? disableCards() : unflipCards();
    }
    function disableCards() {
        firstCard.removeEventListener('click', flipCard);
        secondCard.removeEventListener('click', flipCard);
        resetBoard();
        count++;
        if (count == 3) {
            setTimeout(() => {
                $('#lkbMemoryTerminato')[0].click();
            }, 1000);
        }
    }
    function unflipCards() {
        lockBoard = true;
        setTimeout(() => {
            firstCard.classList.remove('flip');
            secondCard.classList.remove('flip');
            resetBoard();
        }, 750);
    }
    function resetBoard() {
        [hasFlippedCard, lockBoard] = [false, false];
        [firstCard, secondCard] = [null, null];
    }
    (function shuffle() {
        cards.forEach(card => {
            let randomPos = Math.floor(Math.random() * 12);
            card.style.order = randomPos;
        });
    })();

    cards.forEach(card => card.addEventListener('click', flipCard));
}


var $el = $(".wrapper");
var $elHeight = $el.outerHeight();
var $elWidth = $el.outerWidth();
var starterData = {
    size: { width: $(window).width(), height: $(window).height() }
}

function dontScroll(e) {
    e.preventDefault();
}

function doResize(event, ui) {
    var scale, origin;
    scale = Math.min(ui.size.width / $elWidth, ui.size.height / $elHeight);
    $el.css({ transform: "translate(-50%, 0%) " + "scale(" + scale + ")" });
   
    //if ($(window).width() > $(window).height()) {

    //    $('.rotate-device').fadeIn(500);

    //    document.addEventListener("touchstart", dontScroll);
    //    document.addEventListener("touchmove", dontScroll);
    //} else {
    //    $('.rotate-device').fadeOut(500);
    //    document.removeEventListener("touchstart", dontScroll);
    //    document.removeEventListener("touchmove", dontScroll);
    //}

}
function windowResize(e) {
    var resizeData = {
        size: { width: $(window).width(), height: $(window).height() }
    }
    setTimeout(function () {
        doResize(e, resizeData);
    }, 50);
}
window.onresize = windowResize;

/* Ready callback function */
ready(() => {
    initWebpackVersion();

    doResize(null, starterData);

    //imagesload
    if (imagesload) {
        var preload_i = 0;
        var perc;
        $('body').imagesLoaded().always(function (instance) {
            setTimeout(function () {
                hideLoading();
            }, 250);
        }).progress(function (instance, image) {
            preload_i++;
            perc = Math.round((preload_i * 100) / instance.images.length);
        });
    }
    // hamburger
    $('header .hamburger').on('click', function () {
        $(this).toggleClass('is-active');
        $('.item-nav').toggleClass('is-active');
        $('body').toggleClass('nav-is-active');
    });

    // Checkboxes
    $('.form-check').each(function () {
        var required = $('span', this).hasClass("aria-required") ? "true" : "false";
        $('input', this).unwrap('span').addClass('form-check-input').attr("aria-required", required);
        $('label', this).addClass('form-check-label');
    });

    //select
    $('.wrap-select select').each(function () {
        if (!$.trim(this.value).length) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });
    $('.wrap-select select').on('change',function () {
        var thisvalue = this.value;
        //if (!$.trim(this.value).length) { console.log();
        if (!thisvalue.length) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });

});

//***expose functions
window.ValidatorUpdateDisplay = ValidatorUpdateDisplay;
window.ValidationSummaryOnSubmit = ValidationSummaryOnSubmit;
//window.sendjson = sendjson;
//window.countCharacters = countCharacters;
window.scrollToElm = scrollToElm;
//window.scrollToHash = scrollToHash;
//window.scrollToFirstErr = scrollToFirstErr;
window.showLoading = showLoading;
window.hideLoading = hideLoading;
window.closeFancybox = closeFancybox;
window.popMessage = popMessage;
window.popMessageModal = popMessageModal;
window.popInline = popInline;
window.popIframe = popIframe;
//window.setFocusOnElement = setFocusOnElement;
//window.showSpinner = showSpinner;
//window.hideSpinner = hideSpinner;
//window.flexFont = flexFont;
//window.interactionEvent = interactionEvent;
window.startMemory = startMemory;
window.shuffleArray = shuffleArray;
window.pushCards = pushCards;
